import React from "react";

const MortgageRateTable = ({ data, loading }) => {
  if (loading) return <h2>Loading rates...</h2>;
  if (!data.length) return <h2>No rate data found</h2>;

  const renderTable = (category) => {
    const purchase = data.find((row) => row.Type === `${category} Purchase`);
    const refinance = data.find((row) => row.Type === `${category} Refinance`);
    if (!purchase || !refinance) return null;

    const formatNumber = (num) => {
      if (!num || num === "-") return "-";
      return Number(num).toLocaleString("en-US");
    };

    return (
      <table className="styled-table">
        <thead>
          <tr>
            <th colSpan={9} className="tableFirstThHeading">
              <h2>{category}</h2>
            </th>
          </tr>
          <tr>
            <th className="tableFirstTh">
              <span>Home </span>
              <span>Value</span>
            </th>
            <td className="tableFirstThValue">
              ${formatNumber(purchase["Home Value"])}
            </td>
            <th rowSpan={2}></th>
            <th colSpan={2}>30 Yr</th>
            <th colSpan={2}>15 Yr</th>
            <th colSpan={2}>7/6 ARM</th>
          </tr>
          <tr>
            <th className="tableFirstTh">
              <span>Down </span>
              <span>Payment</span>
            </th>
            <td className="tableFirstThValue">{purchase["Down Payment"]}%</td>
            <th>Rate</th>
            <th>APR</th>
            <th>Rate</th>
            <th>APR</th>
            <th>Rate</th>
            <th>APR</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th className="tableFirstTh">
              <span>Loan </span>
              <span>Amount</span>
            </th>
            <td className="tableFirstThValue">
              ${formatNumber(purchase["Loan Amount"])}
            </td>
            <th>Purchase</th>
            <td>{Number(purchase["30 Yr Rate"]).toFixed(3)}%</td>
            <td>{Number(purchase["30 Yr APR"]).toFixed(3)}%</td>
            <td>{Number(purchase["15 Yr Rate"]).toFixed(3)}%</td>
            <td>{Number(purchase["15 Yr APR"]).toFixed(3)}%</td>
            <td>{Number(purchase["7/6 ARM Rate"]).toFixed(3)}%</td>
            <td>{Number(purchase["7/6 ARM APR"]).toFixed(3)}%</td>
          </tr>
          <tr>
            <th className="tableFirstTh">
              <span>Credit </span>
              <span>Score</span>
            </th>
            <td className="tableFirstThValue">{purchase["Credit Score"]}+</td>
            <th>Refinance</th>
            <td>{Number(refinance["30 Yr Rate"]).toFixed(3)}%</td>
            <td>{Number(refinance["30 Yr APR"]).toFixed(3)}%</td>
            <td>{Number(refinance["15 Yr Rate"]).toFixed(3)}%</td>
            <td>{Number(refinance["15 Yr APR"]).toFixed(3)}%</td>
            <td>{Number(refinance["7/6 ARM Rate"]).toFixed(3)}%</td>
            <td>{Number(refinance["7/6 ARM APR"]).toFixed(3)}%</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div className="table-container">
      {renderTable("Primary")}
      {renderTable("Investment")}
    </div>
  );
};

export default MortgageRateTable;
